export default {
  meta: {
    title: '品牌分析'
  }
};
